import { combineReducers } from 'redux';
import {
  GET_USER_PROFILE_FAILED,
  GET_USER_PROFILE_REQUEST,
  GET_USER_PROFILE_SUCCESS,
  SET_TWO_FACTOR_STATUS,
  SET_NEED_TO_LINK_INITIATIVE,
  CONNECT_INNITITATIVE_REQUEST,
  CONNECT_INNITITATIVE_SUCCESS,
  CONNECT_INNITITATIVE_FAILED,
  SET_POST_AUTH_REDIRECT_URL,
  CLEAR_POST_AUTH_REDIRECT_URL,
} from './actionTypes';
import signIn from './SignIn/reducer';
import signUp from './SignUp/reducer';
import forgotPassword from './ForgotPassword/reducer';
import newPassword from './NewPassword/reducer';
import { setPermissions } from '../../core/helpers/auth';

const initialState = {
  user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  permissions: null,
  twoFactorStatus: null,
  userIdForLinkNewInitiative: localStorage.getItem('userIdForLinkNewInitiative'),
  initiativeConnectInProgress: false,
  postAuthRedirectUrl: null,
};

const auth = (state = initialState, {
  type, user, twoFactorStatus, userIdForLinkNewInitiative, url,
}) => {
  switch (type) {
    case GET_USER_PROFILE_REQUEST:
      return {
        ...state, loading: true,
      };
    case GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        user,
        permissions: setPermissions(user.role, user.initiative_role, user.organization_role, user.permissions),
      };
    case GET_USER_PROFILE_FAILED:
      return {
        ...state, loading: false,
      };
    case SET_TWO_FACTOR_STATUS:
      return {
        ...state, twoFactorStatus,
      };
    case SET_NEED_TO_LINK_INITIATIVE:
      return {
        ...state, userIdForLinkNewInitiative,
      };
    case CONNECT_INNITITATIVE_REQUEST:
      return {
        ...state, initiativeConnectInProgress: true,
      };
    case CONNECT_INNITITATIVE_SUCCESS:
      return {
        ...state, initiativeConnectInProgress: false,
      };
    case CONNECT_INNITITATIVE_FAILED:
      return {
        ...state, initiativeConnectInProgress: false,
      };
    case SET_POST_AUTH_REDIRECT_URL:
      return {
        ...state, postAuthRedirectUrl: url,
      };
    case CLEAR_POST_AUTH_REDIRECT_URL:
      return {
        ...state, postAuthRedirectUrl: null,
      };
    default:
      return state;
  }
};

const authReducer = combineReducers({
  auth,
  signIn,
  signUp,
  forgotPassword,
  newPassword,
});

export default authReducer;
